var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFile(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 24,
    height: 24,
    x: 0,
    y: 0,
    viewBox: "0 0 32 32",
    style: {
      enableBackground: "new 0 0 512 512"
    },
    xmlSpace: "preserve",
    fillRule: "evenodd",
    className: "",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M16 28a5 5 0 0 1-5-5V6.998A2.999 2.999 0 0 1 13.998 4h.004A2.998 2.998 0 0 1 17 6.998v14.004a.998.998 0 0 1-.998.998H16a1 1 0 0 1-1-1V9a1 1 0 0 0-2 0v12a3 3 0 0 0 3 3h.002A2.998 2.998 0 0 0 19 21.002V6.998A4.998 4.998 0 0 0 14.002 2h-.004A5 5 0 0 0 9 6.998V23a7 7 0 1 0 14 0V9a1 1 0 0 0-2 0v14a5 5 0 0 1-5 5z",
    fill: "#9dcfc7",
    opacity: 1,
    "data-original": "#000000",
    className: ""
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFile);
export default __webpack_public_path__ + "static/media/file.d94c0c1b31f7f90f2811b86f5decf123.svg";
export { ForwardRef as ReactComponent };